import React, { useState } from 'react';
import { PieChart, Pie, Cell, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { ShieldAlertIcon, AlertTriangleIcon, CheckCircleIcon, ActivityIcon, XIcon, MapPinIcon, ClockIcon, GaugeIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const faultDistribution = [{
  name: 'Meter Bypassing',
  value: 32,
  color: '#ef4444'
}, {
  name: 'Illegal Connections',
  value: 28,
  color: '#E07020'
}, {
  name: 'Inaccurate Readings',
  value: 22,
  color: '#EAB308'
}, {
  name: 'Tamper Detection',
  value: 12,
  color: '#8b5cf6'
}, {
  name: 'Reverse Energy Flow',
  value: 6,
  color: '#3b82f6'
}];
const alertsOverTime = [{
  day: 'Mon',
  value: 12
}, {
  day: 'Tue',
  value: 8
}, {
  day: 'Wed',
  value: 15
}, {
  day: 'Thu',
  value: 6
}, {
  day: 'Fri',
  value: 10
}, {
  day: 'Sat',
  value: 18
}, {
  day: 'Sun',
  value: 9
}];
const alertsData = [{
  id: 'ALT-9021',
  meterId: '04-1001-2002-30',
  severity: 'Critical',
  type: 'Meter Bypassing',
  description: 'Abnormal consumption drop detected, possible meter bypass',
  location: 'Soweto',
  detected: '2 hours ago',
  status: 'Active',
  revenueLoss: 4500,
  riskLevel: 'High Risk',
  actions: ['Dispatch field technician immediately', 'Inspect physical meter seals', 'Check secondary supply lines']
}, {
  id: 'ALT-9020',
  meterId: '04-2002-3003-40',
  severity: 'High',
  type: 'Illegal Connection',
  description: 'Unauthorized load detected on feeder line',
  location: 'Tembisa',
  detected: '5 hours ago',
  status: 'Investigating',
  revenueLoss: 2800,
  riskLevel: 'High Risk',
  actions: ['Coordinate with local authorities', 'Trace feeder line connections', 'Document illegal tap points']
}, {
  id: 'ALT-9019',
  meterId: '04-3003-4004-50',
  severity: 'Medium',
  type: 'Inaccurate Meter Reading',
  description: 'Reading deviation exceeds 15% threshold',
  location: 'Khayelitsha',
  detected: '1 day ago',
  status: 'Active',
  revenueLoss: 850,
  riskLevel: 'Medium Risk',
  actions: ['Schedule meter recalibration', 'Compare with historical averages', 'Check for firmware updates']
}, {
  id: 'ALT-9018',
  meterId: '04-4004-5005-60',
  severity: 'High',
  type: 'Tamper Detection',
  description: 'Physical tamper switch triggered',
  location: 'Mamelodi',
  detected: '1 day ago',
  status: 'Resolved',
  revenueLoss: 0,
  riskLevel: 'Medium Risk',
  actions: ['Verify tamper switch status', 'Reset tamper flag if false alarm', 'Inspect meter enclosure']
}, {
  id: 'ALT-9017',
  meterId: '04-5005-6006-70',
  severity: 'Low',
  type: 'Reverse Energy Flow',
  description: 'Negative energy flow detected, possible backfeed',
  location: 'Umlazi',
  detected: '2 days ago',
  status: 'Active',
  revenueLoss: 120,
  riskLevel: 'Low Risk',
  actions: ['Verify solar/generator installation', 'Check meter configuration', 'Contact customer for clarification']
}, {
  id: 'ALT-9016',
  meterId: '04-6006-7007-80',
  severity: 'Critical',
  type: 'Meter Bypassing',
  description: 'Abnormal consumption drop detected, possible meter bypass',
  location: 'Sandton',
  detected: '2 days ago',
  status: 'Investigating',
  revenueLoss: 12500,
  riskLevel: 'High Risk',
  actions: ['Dispatch field technician immediately', 'Inspect physical meter seals', 'Check secondary supply lines']
}, {
  id: 'ALT-9015',
  meterId: '04-7007-8008-90',
  severity: 'Medium',
  type: 'Inaccurate Meter Reading',
  description: 'Reading deviation exceeds 15% threshold',
  location: 'Pretoria',
  detected: '3 days ago',
  status: 'Resolved',
  revenueLoss: 420,
  riskLevel: 'Medium Risk',
  actions: ['Schedule meter recalibration', 'Compare with historical averages', 'Check for firmware updates']
}, {
  id: 'ALT-9014',
  meterId: '04-8008-9009-00',
  severity: 'High',
  type: 'Illegal Connection',
  description: 'Unauthorized load detected on feeder line',
  location: 'Durban',
  detected: '3 days ago',
  status: 'Active',
  revenueLoss: 3100,
  riskLevel: 'High Risk',
  actions: ['Coordinate with local authorities', 'Trace feeder line connections', 'Document illegal tap points']
}, {
  id: 'ALT-9013',
  meterId: '04-9009-0000-11',
  severity: 'Critical',
  type: 'Tamper Detection',
  description: 'Physical tamper switch triggered',
  location: 'Soweto',
  detected: '4 days ago',
  status: 'Investigating',
  revenueLoss: 0,
  riskLevel: 'High Risk',
  actions: ['Verify tamper switch status', 'Reset tamper flag if false alarm', 'Inspect meter enclosure']
}, {
  id: 'ALT-9012',
  meterId: '04-0000-1111-22',
  severity: 'Low',
  type: 'Reverse Energy Flow',
  description: 'Negative energy flow detected, possible backfeed',
  location: 'Tembisa',
  detected: '5 days ago',
  status: 'Resolved',
  revenueLoss: 0,
  riskLevel: 'Low Risk',
  actions: ['Verify solar/generator installation', 'Check meter configuration', 'Contact customer for clarification']
}, {
  id: 'ALT-9011',
  meterId: '04-1111-2222-33',
  severity: 'Medium',
  type: 'Inaccurate Meter Reading',
  description: 'Reading deviation exceeds 15% threshold',
  location: 'Khayelitsha',
  detected: '6 days ago',
  status: 'Active',
  revenueLoss: 650,
  riskLevel: 'Medium Risk',
  actions: ['Schedule meter recalibration', 'Compare with historical averages', 'Check for firmware updates']
}, {
  id: 'ALT-9010',
  meterId: '04-2222-3333-44',
  severity: 'High',
  type: 'Meter Bypassing',
  description: 'Abnormal consumption drop detected, possible meter bypass',
  location: 'Mamelodi',
  detected: '1 week ago',
  status: 'Resolved',
  revenueLoss: 5200,
  riskLevel: 'High Risk',
  actions: ['Dispatch field technician immediately', 'Inspect physical meter seals', 'Check secondary supply lines']
}];
export function FaultDetection() {
  const [activeFilter, setActiveFilter] = useState('All');
  const [selectedAlertId, setSelectedAlertId] = useState<string | null>(null);
  const filteredAlerts = alertsData.filter(alert => {
    return activeFilter === 'All' || alert.severity === activeFilter;
  });
  const selectedAlert = alertsData.find(a => a.id === selectedAlertId);
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'Critical':
        return 'text-red-600';
      case 'High':
        return 'text-orange-500';
      case 'Medium':
        return 'text-yellow-500';
      case 'Low':
        return 'text-blue-500';
      default:
        return 'text-gray-500';
    }
  };
  const getSeverityDot = (severity: string) => {
    switch (severity) {
      case 'Critical':
        return 'bg-red-600';
      case 'High':
        return 'bg-orange-500';
      case 'Medium':
        return 'bg-yellow-500';
      case 'Low':
        return 'bg-blue-500';
      default:
        return 'bg-gray-500';
    }
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-red-100 text-red-800';
      case 'Investigating':
        return 'bg-orange-100 text-orange-800';
      case 'Resolved':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-980">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 gap-4" data-id="element-981">
        <div data-id="element-982">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-983">
            Fault Detection & Alerts
          </h1>
          <p className="text-gray-500" data-id="element-984">
            Monitor meter anomalies, tampering attempts, and system faults.
          </p>
        </div>
        <div className="flex border border-gray-200 rounded-none overflow-hidden shadow-sm" data-id="element-985">
          {['All', 'Critical', 'High', 'Medium', 'Low'].map(tab => {
          const isActive = activeFilter === tab;
          return <button key={tab} onClick={() => setActiveFilter(tab)} className={`px-4 py-2 text-sm font-medium transition-colors ${isActive ? 'bg-mavis-teal text-white' : 'bg-white text-gray-600 hover:bg-gray-50 border-r border-gray-200 last:border-r-0'}`} data-id="element-986">

                {tab}
              </button>;
        })}
        </div>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-987">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-988">
          <div className="p-3 bg-red-50 text-red-600 rounded-none" data-id="element-989">
            <ShieldAlertIcon className="w-5 h-5" data-id="element-990" />
          </div>
          <div data-id="element-991">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-992">
              Total Faults Detected
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-993">287</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-994">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-995">
            <AlertTriangleIcon className="w-5 h-5" data-id="element-996" />
          </div>
          <div data-id="element-997">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-998">
              Active Alerts
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-999">43</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1000">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-1001">
            <CheckCircleIcon className="w-5 h-5" data-id="element-1002" />
          </div>
          <div data-id="element-1003">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1004">
              Resolved (30 days)
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1005">244</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1006">
          <div className="p-3 bg-blue-50 text-blue-600 rounded-none" data-id="element-1007">
            <ActivityIcon className="w-5 h-5" data-id="element-1008" />
          </div>
          <div data-id="element-1009">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1010">
              Detection Rate
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1011">98.5%</p>
          </div>
        </div>
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-1012">
        {/* Fault Type Distribution */}
        <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200" data-id="element-1013">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1014">
            Fault Type Distribution
          </h2>
          <div className="h-80 flex items-center justify-center" data-id="element-1015">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1016">
              <PieChart data-id="element-1017">
                <Pie data={faultDistribution} cx="50%" cy="50%" innerRadius={80} outerRadius={120} paddingAngle={5} dataKey="value" data-id="element-1018">

                  {faultDistribution.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1019" />)}
                </Pie>
                <Tooltip formatter={value => [`${value}%`, 'Share']} contentStyle={{
                borderRadius: '0',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1020" />


                <Legend verticalAlign="bottom" height={36} iconType="circle" data-id="element-1021" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Alerts Over Time */}
        <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200" data-id="element-1022">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1023">
            Alerts Over Time
          </h2>
          <div className="h-80" data-id="element-1024">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1025">
              <AreaChart data={alertsOverTime} margin={{
              top: 10,
              right: 10,
              left: 0,
              bottom: 0
            }} data-id="element-1026">

                <defs data-id="element-1027">
                  <linearGradient id="colorAlerts" x1="0" y1="0" x2="0" y2="1" data-id="element-1028">
                    <stop offset="5%" stopColor="#ef4444" stopOpacity={0.3} data-id="element-1029" />
                    <stop offset="95%" stopColor="#E07020" stopOpacity={0} data-id="element-1030" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1031" />


                <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} dy={10} data-id="element-1032" />


                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} data-id="element-1033" />


                <Tooltip formatter={(value: number) => [`${value}`, 'Alerts']} contentStyle={{
                borderRadius: '0',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1034" />


                <Area type="monotone" dataKey="value" stroke="#ef4444" strokeWidth={2} fillOpacity={1} fill="url(#colorAlerts)" data-id="element-1035" />

              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Alerts Table */}
      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-1036">
        <div className="overflow-x-auto" data-id="element-1037">
          <table className="w-full text-left border-collapse" data-id="element-1038">
            <thead data-id="element-1039">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-1040">
                <th className="p-4 font-medium" data-id="element-1041">Severity</th>
                <th className="p-4 font-medium" data-id="element-1042">Alert ID</th>
                <th className="p-4 font-medium" data-id="element-1043">Meter ID</th>
                <th className="p-4 font-medium" data-id="element-1044">Fault Type</th>
                <th className="p-4 font-medium" data-id="element-1045">Location</th>
                <th className="p-4 font-medium" data-id="element-1046">Detected</th>
                <th className="p-4 font-medium" data-id="element-1047">Status</th>
                <th className="p-4 font-medium text-right" data-id="element-1048">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1049">
              {filteredAlerts.map(alert => <tr key={alert.id} onClick={() => setSelectedAlertId(alert.id)} className="hover:bg-gray-50 transition-colors group cursor-pointer" data-id="element-1050">

                  <td className="p-4" data-id="element-1051">
                    <div className="flex items-center gap-2" data-id="element-1052">
                      <div className={`w-2 h-2 rounded-full ${getSeverityDot(alert.severity)}`} data-id="element-1053">
                    </div>
                      <span className={`text-sm font-medium ${getSeverityColor(alert.severity)}`} data-id="element-1054">

                        {alert.severity}
                      </span>
                    </div>
                  </td>
                  <td className="p-4 font-mono text-sm text-gray-900" data-id="element-1055">
                    {alert.id}
                  </td>
                  <td className="p-4 font-mono text-sm text-gray-900" data-id="element-1056">
                    {alert.meterId}
                  </td>
                  <td className="p-4" data-id="element-1057">
                    <p className="font-medium text-gray-900 text-sm" data-id="element-1058">
                      {alert.type}
                    </p>
                    <p className="text-xs text-gray-500 truncate max-w-[200px]" data-id="element-1059">
                      {alert.description}
                    </p>
                  </td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-1060">
                    {alert.location}
                  </td>
                  <td className="p-4 text-sm text-gray-500" data-id="element-1061">
                    {alert.detected}
                  </td>
                  <td className="p-4" data-id="element-1062">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${getStatusBadge(alert.status)}`} data-id="element-1063">

                      {alert.status}
                    </span>
                  </td>
                  <td className="p-4 text-right" data-id="element-1064">
                    <button className="text-sm font-medium text-mavis-teal hover:underline" data-id="element-1065">
                      Investigate
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredAlerts.length === 0 && <div className="text-center py-12" data-id="element-1066">
            <ShieldAlertIcon className="w-12 h-12 text-gray-300 mx-auto mb-3" data-id="element-1067" />
            <h3 className="text-lg font-medium text-gray-900" data-id="element-1068">
              No alerts found
            </h3>
            <p className="text-gray-500" data-id="element-1069">
              Try adjusting your severity filters.
            </p>
          </div>}
      </div>

      {/* Detail Panel Backdrop */}
      {selectedAlertId && <div className="fixed inset-0 bg-black/50 z-40 transition-opacity" onClick={() => setSelectedAlertId(null)} data-id="element-1070" />}

      {/* Detail Panel */}
      <div className={`fixed right-0 top-0 h-full w-full max-w-[500px] bg-white z-50 shadow-2xl border-l border-gray-200 transform transition-transform duration-300 ease-in-out overflow-y-auto ${selectedAlertId ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-1071">

        {selectedAlert && <div className="flex flex-col h-full" data-id="element-1072">
            {/* Header */}
            <div className="p-6 border-b border-gray-100 flex justify-between items-start bg-gray-50" data-id="element-1073">
              <div data-id="element-1074">
                <div className="flex items-center gap-2 mb-2" data-id="element-1075">
                  <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-none text-xs font-medium border border-gray-200 bg-white ${getSeverityColor(selectedAlert.severity)}`} data-id="element-1076">

                    <div className={`w-1.5 h-1.5 rounded-full ${getSeverityDot(selectedAlert.severity)}`} data-id="element-1077">
                  </div>
                    {selectedAlert.severity}
                  </span>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-none text-xs font-medium ${getStatusBadge(selectedAlert.status)}`} data-id="element-1078">

                    {selectedAlert.status}
                  </span>
                </div>
                <h2 className="text-2xl font-bold font-mono text-gray-900 leading-tight" data-id="element-1079">
                  {selectedAlert.id}
                </h2>
              </div>
              <button onClick={() => setSelectedAlertId(null)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-none transition-colors" data-id="element-1080">

                <XIcon className="w-6 h-6" data-id="element-1081" />
              </button>
            </div>

            <div className="p-6 space-y-8 flex-1" data-id="element-1082">
              {/* Fault Details */}
              <section data-id="element-1083">
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-1084">
                  Fault Details
                </h3>
                <div className="space-y-4" data-id="element-1085">
                  <div data-id="element-1086">
                    <p className="text-sm text-gray-500 mb-1" data-id="element-1087">Fault Type</p>
                    <p className="font-bold text-gray-900 text-lg" data-id="element-1088">
                      {selectedAlert.type}
                    </p>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-1089">
                      {selectedAlert.description}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-50" data-id="element-1090">
                    <div className="flex items-start gap-2" data-id="element-1091">
                      <GaugeIcon className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" data-id="element-1092" />
                      <div data-id="element-1093">
                        <p className="text-xs text-gray-500" data-id="element-1094">Meter ID</p>
                        <p className="font-mono font-medium text-gray-900" data-id="element-1095">
                          {selectedAlert.meterId}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-1096">
                      <MapPinIcon className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" data-id="element-1097" />
                      <div data-id="element-1098">
                        <p className="text-xs text-gray-500" data-id="element-1099">Location</p>
                        <p className="font-medium text-gray-900" data-id="element-1100">
                          {selectedAlert.location}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 col-span-2" data-id="element-1101">
                      <ClockIcon className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" data-id="element-1102" />
                      <div data-id="element-1103">
                        <p className="text-xs text-gray-500" data-id="element-1104">Detected Time</p>
                        <p className="font-medium text-gray-900" data-id="element-1105">
                          {selectedAlert.detected}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Impact Assessment */}
              <section className="bg-red-50 p-5 rounded-none border border-red-100" data-id="element-1106">
                <h3 className="text-sm font-bold text-red-900 uppercase tracking-wider mb-4" data-id="element-1107">
                  Impact Assessment
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1108">
                  <div data-id="element-1109">
                    <p className="text-xs text-red-700 uppercase tracking-wider mb-1" data-id="element-1110">
                      Est. Revenue Loss
                    </p>
                    <p className="font-mono font-bold text-red-600 text-xl" data-id="element-1111">
                      {formatZAR(selectedAlert.revenueLoss)}
                    </p>
                  </div>
                  <div data-id="element-1112">
                    <p className="text-xs text-red-700 uppercase tracking-wider mb-1" data-id="element-1113">
                      Risk Level
                    </p>
                    <p className="font-bold text-red-900 text-lg" data-id="element-1114">
                      {selectedAlert.riskLevel}
                    </p>
                  </div>
                </div>
              </section>

              {/* Recommended Actions */}
              <section data-id="element-1115">
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-1116">
                  Recommended Actions
                </h3>
                <ul className="space-y-3" data-id="element-1117">
                  {selectedAlert.actions.map((action, index) => <li key={index} className="flex items-start gap-3" data-id="element-1118">
                      <div className="w-5 h-5 rounded-full bg-mavis-teal/10 text-mavis-teal flex items-center justify-center text-xs font-bold shrink-0 mt-0.5" data-id="element-1119">
                        {index + 1}
                      </div>
                      <span className="text-sm text-gray-700" data-id="element-1120">{action}</span>
                    </li>)}
                </ul>
              </section>
            </div>

            {/* Quick Actions Footer */}
            <div className="p-6 border-t border-gray-100 bg-gray-50 grid grid-cols-1 gap-3" data-id="element-1121">
              <button className="w-full py-3 text-white font-medium rounded-none hover:bg-mavis-teal/90 transition-colors flex items-center justify-center gap-2 shadow-sm bg-[#002F3E]" data-id="element-1122">
                <ActivityIcon className="w-4 h-4" data-id="element-1123" /> Dispatch Field Team
              </button>
              <div className="grid grid-cols-2 gap-3" data-id="element-1124">
                <button className="w-full py-2 bg-white border border-gray-300 text-gray-700 font-medium rounded-none hover:bg-gray-50 transition-colors text-sm shadow-sm" data-id="element-1125">
                  Mark as Investigating
                </button>
                <button className="w-full py-2 bg-white border border-gray-300 text-gray-700 font-medium rounded-none hover:bg-gray-50 transition-colors text-sm shadow-sm" data-id="element-1126">
                  Dismiss Alert
                </button>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}